<div class="d-flex justify-content-center align-items-center border border-right bg-dark rounded text-white">

  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" #sldPdfEl title="SLD" i18n-title="@@app.sld" appDisableMultipleClickWithNoneEvent (click)="generatePdf(sldPdfEl?.title)">
    <i class="icon-24 se-icon-action_pdf_report font-size-24 font-weight-semibold"></i>
  </div>
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Zoom In" i18n-title="@@app.zoom_in"
       (click)="zoomInGrid()">
    <i class="icon-24 se-icon-action_zoom_plus_stroke font-size-24 font-weight-semibold"></i>
  </div>
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Zoom Out" i18n-title="@@app.zoom_out"
       (click)="zoomOutGrid()">
    <i class="icon-24 se-icon-action_zoom_minus_stroke font-size-24 font-weight-semibold"></i>
  </div>
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Fit To Window" i18n-title="@@app.fit_to_window" (click)="fitToWindow()">
    <i class="icon-24 se-icon-action_resize font-size-24 font-weight-semibold"></i>
  </div>
</div>
